jQuery(window).ready(function() {


   jQuery(document).on('click', '.alterar-local', function(event){

      event.preventDefault()

      var id = jQuery(this).attr('data-id');
      var area_comentario = jQuery('.lity-container');
      var elemento = jQuery(this);

      area_comentario.loading({
         theme: 'dark',
         message: "<i class='fa fa-circle-o-notch font-24 fa-spin'></i>",
     });

     //Obter trilhas e status
     jQuery.ajax({
         type: 'POST',
         url: config.ajax_url,
         data: {
             'action': 'AlterarRegiao',
             'id': id,
         },
         dataType: 'json',
         success: function(dados) {

             if (dados.status == "ok") {

               window.location.href = elemento.closest('ul').attr('data-home');

             }else{

               area_comentario.loading('stop');
               alert(data.mensagem);

             }


         },
         error: function (xhr) {
             alert(xhr.responseText);
         },
         complete: function()
         {
         }
     });


   });


   jQuery('.stores-carousel .carousel-itens').slick();



   jQuery('.store-page-carousel').slick({
      centerMode: true,
      autoplay: true,
      slidesToShow: 4
   });


   jQuery('.navbar-toggler').click(function() {
      jQuery('.navbar-toggler').toggleClass("active");
      jQuery('.header-navbar').toggleClass("open");
   });



   jQuery('.store-page-carousel').slick({
      slidesToShow: 3,
      slidesToScroll: false,
      centerMode: true,
      responsive: [
         {
            breakpoint: 992,
            settings: {
               slidesToShow: 2
            }
         },
         {
            breakpoint: 576,
            settings: {
               slidesToShow: 1
            }
         }
      ]
   });




});